<template>
	<div
		class="tag-new-feature"
		v-if="$ms.commonFunc.checkCurrentPassedNumberDay()"
	>
		{{ $t('i18nNotification.NotificationTooltip.TagNew') }}
	</div>
</template>
<script>
export default {
	name: 'msTagNew',
	props: {
		dataRow: {
			type: Object,
			default: () => {},
		},
	},
	computed: {},
	methods: {},
};
</script>
<style lang="scss">
</style>